(function ($) {
    class RLM_Navigation {
        constructor () {
            if (!$('a[data-dynamic="true"]').length) {
                return;
            }

            this.isMobile = false;
            this.mobileViewport = window.matchMedia('screen and (max-width: 768px)');
            this.desktopViewport = window.matchMedia('screen and (min-width: 769px)');
            
            if (this.mobileViewport.matches) {
                this.isMobile = true;
            }

            this.initState();        
            this.initEvents();
            this.createCache();

            this.mobileViewport.addListener(mq => {
                if (mq.matches) {
                    this.isMobile = true;
                }
            });
    
            this.desktopViewport.addListener(mq => {
                if (mq.matches) {
                    this.isMobile = false;
                }
            });
        }
    
        initState () {
            this.activatorID = '';
            this.originURL = '';
            this.win = $(window);
            this.body = $(document.body);
            this.wrapperForContent = $('#dynamic-subpage-content');
            this.menuBar = $('.menu-top-bar');
            this.menuIcon = this.menuBar.find('.menu-icon');
            this.closeMenuIcon = this.menuBar.find('.close-icon');
            this.logo = this.menuBar.find('.logo');
        }
    
        initEvents () {
            this.closeMenuIcon.on('click', e => {
                if (!this.isMobile) {
                    e.preventDefault();
                    this.closeSubpage();
                }
            });

            this.logo.on('click', e => {
                if (!this.isMobile) {
                    if (this.originURL !== false) {
                        e.preventDefault();
                        this.closeSubpage();
                    }
                }
            });

            $('a[data-dynamic="true"]').each((i, link) => {
                $(link).on('click', e => {
                    if (!this.isMobile) {
                        e.preventDefault();
                        this.showSubpage(link);
                    }
                });
            });

            window.addEventListener('popstate', (event) => {
                if (!this.isMobile) {
                    if (this.originURL) {
                        this.closeSubpage();
                    }
                }
            }, false);
        }

        createCache () {
            this.cache = [];

            $('a[data-dynamic="true"]').each((i, link) => {
                let url = $(link).attr('href');

                $.ajax(url).done((res) => {
                    this.cache[url] = res;
                });
            });
        }

        closeSubpage () {
            let callbackRunned = false;
            let links = $('.menu-top-bar .menu-item a');
            links.removeClass('current');

            $('html, body').animate({
                scrollTop: 0
            }, 500, () => {
                if (!callbackRunned) {
                    callbackRunned = true;
                } else {
                    return;
                }

                window.history.pushState(null, null, this.originURL);
                this.closeMenuIcon.addClass('is-hidden');
                this.menuIcon.removeClass('is-hidden');
                this.body.removeClass('is-subpage-open');
                this.wrapperForContent.addClass('is-hiding');

                $('#dynamic-subpage-content *[data-dynamic-hideable="true"]').css('display', 'none');

                $('body > *[data-dynamic-hideable="true"], body > main *[data-dynamic-hideable="true"]').each((i, block) => {
                    if ($(block).attr('id') !== this.activatorID) {
                        $(block).css('display', 'block');
                    } else {
                        $(block).css('position', 'relative');
                        $(block).css('top', 0);
                    }
                });

                let offset = 0;
                
                if (this.activatorID !== '') {
                    offset = ($('#' + this.activatorID).offset().top + $('#' + this.activatorID).outerHeight()) - this.win.height();
                }

                if (window.safari) {
                    $(document.body).scrollTop(offset);
                    this.wrapperForContent.css('top', offset + 'px');
                    
                    setTimeout(() => {
                        $(document.body).scrollTop(offset);
                        this.wrapperForContent.css('top', offset + 'px');
                    }, 0);
                } else {
                    $(window).scrollTop(offset);
                    this.wrapperForContent.css('top', offset + 'px');
                }
                
                setTimeout(() => {
                    this.wrapperForContent.addClass('is-invisible');
                    
                    if (this.VMJoinUsCTA) {
                        this.VMJoinUsCTA.clear();
                    }

                    if (this.VMAnimatedBlocks) {
                        this.VMAnimatedBlocks.clear();
                    }

                    if (window.VMAnimatedBlocksInstance) {
                        window.VMAnimatedBlocksInstance.addEvents();

                        setTimeout(() => {
                            window.VMAnimatedBlocksInstance.recalculate();
                        }, 100);
                    }
                }, 500);

                setTimeout(() => {
                    this.wrapperForContent.empty();
                    this.wrapperForContent.removeClass('is-hiding').removeClass('is-invisible').addClass('is-hidden');
                    this.wrapperForContent.css('top', '');
                    this.originURL = false;
                }, 1500);
            });
        }

        showSubpage (link) {
            let destinationUrl = $(link).attr('href');
            this.activatorID = $(link).attr('data-dynamic-id');
            this.originURL = window.location.href;
            let links = $('.menu-top-bar .menu-item a');
            links.removeClass('current');

            for (let i = 0; i < links.length; i++) {
                if (links.eq(i).attr('href') === destinationUrl) {
                    links.eq(i).addClass('current');
                }
            }

            $('html, body').animate({
                scrollTop: ($('#' + this.activatorID).offset().top + $('#' + this.activatorID).outerHeight()) - this.win.outerHeight()
            }, 500, () => {
                this.body.addClass('is-subpage-open');
                this.body.addClass('no-scroll');
                window.history.pushState(null, null, destinationUrl);
                this.closeMenuIcon.removeClass('is-hidden');
                this.menuIcon.addClass('is-hidden');
                this.loadSubpage(destinationUrl);
            });
        }

        loadSubpage (url) {
            if (this.cache[url]) {
                this.renderSubpage(this.cache[url]);
            } else {
                $.ajax(url).done((res) => {
                    this.renderSubpage(res);
                }).fail(() => {
                    this.body.removeClass('no-scroll');
                });
            }
        }

        renderSubpage (res) {
            let html = $('<div>' + res + '</div>');
            let output = html.find('main.page-content');
            let footerOutput = html.find('.site-footer');
            this.wrapperForContent.empty().html(output.html() + footerOutput[0].outerHTML);
            
            if ($('#' + this.activatorID).find('.animated-block-inner').length) {
                let originalContent = $('#' + this.activatorID).find('.animated-block-inner');
                let contentCopy = originalContent.clone();
                originalContent.css('opacity', 0);
                contentCopy.css('position', 'fixed');
                contentCopy.css('bottom', 0);
                contentCopy.css('width', '100%');
                contentCopy.css('z-index', 9);
                contentCopy.appendTo(document.body);

                setTimeout(() => {
                    contentCopy.remove();
                    originalContent.css('opacity', 1);
                }, 1000);
            }

            setTimeout(() => {
                this.wrapperForContent.removeClass('is-hidden');
                $(window).scrollTop(0);
                new RLM_ContactSlider(this.wrapperForContent[0]);
                new RLM_ToolsSlider(this.wrapperForContent[0]);
                new RLM_SmoothScroll(this.wrapperForContent[0]);
                new RLM_ToolsTabs(this.wrapperForContent[0]);
                new RLM_Popup(this.wrapperForContent[0]);
                this.VMJoinUsCTA = new RLM_JoinUsCta(this.wrapperForContent[0]);
                new RLM_AnimatedList(this.wrapperForContent[0]);

                for (let i = 0; i < this.wrapperForContent.eq(0).find('.js-toggle-content').length; i++) {
                    new RLM_ToggleText(this.wrapperForContent.eq(0).find('.js-toggle-content').eq(i));
                }

                $('body > *[data-dynamic-hideable="true"], body > main *[data-dynamic-hideable="true"]').each((i, block) => {
                    if ($(block).attr('id') !== this.activatorID) {
                        $(block).css('display', 'none');
                    } else {
                        $(block).css('position', 'absolute');
                        $(block).css('top', 0);
                    }
                });

                this.body.removeClass('no-scroll');
                window.VMAnimatedBlocksInstance.clear();
                this.VMAnimatedBlocks = new RLM_AnimatedBlocks(this.wrapperForContent[0], true);
                setTimeout(() => {
                    AOS.refreshHard();
                }, 500);
            }, 300);
        }
    }
    
    new RLM_Navigation();
})(jQuery);